const persister = 'explisoft';
export const loadState = () => {
    try {
        const serializedState = localStorage.getItem(persister);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(persister, serializedState);
    } catch {
        // ignore write errors
    }
};
